import { Stack, Text } from '@ltvco/refresh-lib/theme';
import { nameize } from '@ltvco/refresh-lib/utils';

import { ContactReportSummaryData } from '../DataTypes/SummaryTypes';

import { BoldSpan } from './components';

interface ContactReportRendererProps {
  data: ContactReportSummaryData;
}

export const ContactReportRenderer = ({ data }: ContactReportRendererProps) => {
  return (
    <Stack spacing={2}>
      <Text>
        Here's a professional contact summary for{' '}
        <BoldSpan>{data.personName}</BoldSpan>:
      </Text>
      <Stack spacing={1.5}>
        <Text>
          <BoldSpan>Summary</BoldSpan>
        </Text>
        <Text>
          <BoldSpan>Job Title:</BoldSpan>{' '}
          {nameize(data?.jobs?.[0]?.title) || '-'}
        </Text>
        <Text>
          <BoldSpan>Company:</BoldSpan>{' '}
          {nameize(data?.jobs?.[0]?.company) || '-'}
        </Text>
        <Text>
          <BoldSpan>Aliases:</BoldSpan>{' '}
          {data.aliases?.length > 0
            ? data.aliases.map((alias) => nameize(alias)).join(', ')
            : '-'}
        </Text>
      </Stack>
      <Stack spacing={1.5}>
        <Text>
          <BoldSpan>Contact Info</BoldSpan>
        </Text>
        <Text>📞 {data.phone || '-'}</Text>
        <Text>✉️ {data.email || '-'}</Text>
        <Text>🏠 {data.address || '-'}</Text>
      </Stack>
      <Stack spacing={1.5}>
        <Text>
          <BoldSpan>Social Media</BoldSpan>
        </Text>
        {data.social?.length > 0
          ? data.social.map((social) => (
              <Text key={social.user_id}>{social.user_id}</Text>
            ))
          : '-'}
      </Stack>
      <Stack spacing={1.5}>
        <Text>
          <BoldSpan>Employment History</BoldSpan>
        </Text>
        {data.jobs?.length > 0
          ? data.jobs.map((job) => (
              <Text key={job.title}>
                {nameize(job.title)} at {nameize(job.company)}
              </Text>
            ))
          : '-'}
      </Stack>
      <Stack spacing={1.5}>
        <Text>
          <BoldSpan>Education</BoldSpan>
        </Text>
        <Text>{nameize(data.education) || '-'}</Text>
      </Stack>
    </Stack>
  );
};
